<ml-mdm-command-spinner [commandProgress]="commandProgress$">
  <ml-mdm-restrictions-settings [(restrictionsProfile)]="payloadContent"></ml-mdm-restrictions-settings>

  <p class="text-end">
    <button class="btn btn-link px-0"
            (click)="showMore = !showMore">more</button>
  </p>
  <div [class.collapse]="!showMore">
    <ml-mdm-configuration-payload [(payloadContent)]="payloadContent"
                                  [mutate]="true"></ml-mdm-configuration-payload>
    <ml-mdm-configuration-profile [(configurationProfile)]="configurationProfile"
                                  [mutate]="true"></ml-mdm-configuration-profile>
  </div>

  <button type="submit"
          class="btn btn-primary"
          (click)="installProfile(udid())">
    <fa-icon icon="file-upload"></fa-icon>
    <span class="ms-2"
          i18n>Install</span>
  </button>
</ml-mdm-command-spinner>